/* ICONIX MEMORABILIA — interactions */
(function () {
  'use strict';

  /* Sticky header state */
  var header = document.querySelector('.header');
  if (header) {
    var onScroll = function () { header.classList.toggle('scrolled', window.scrollY > 20); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Mobile menu */
  var burger = document.querySelector('.burger');
  var menu = document.querySelector('.mobile-menu');
  if (burger && menu) {
    burger.addEventListener('click', function () { menu.classList.toggle('open'); });
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { menu.classList.remove('open'); });
    });
  }

  /* Scroll reveal */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('in'); });
  }

  /* Animated counters */
  var counters = document.querySelectorAll('[data-count]');
  if ('IntersectionObserver' in window && counters.length) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target, target = parseFloat(el.dataset.count),
            suffix = el.dataset.suffix || '', dur = 1400, start = null;
        var step = function (ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var val = Math.floor((1 - Math.pow(1 - p, 3)) * target);
          el.textContent = val + suffix;
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
        cio.unobserve(el);
      });
    }, { threshold: 0.5 });
    counters.forEach(function (el) { cio.observe(el); });
  }

  /* Countdown timer */
  var cd = document.querySelector('[data-deadline]');
  if (cd) {
    var deadline = new Date(cd.dataset.deadline).getTime();
    var els = {
      d: cd.querySelector('[data-d]'), h: cd.querySelector('[data-h]'),
      m: cd.querySelector('[data-m]'), s: cd.querySelector('[data-s]')
    };
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var tick = function () {
      var diff = deadline - Date.now();
      if (diff < 0) diff = 0;
      var d = Math.floor(diff / 86400000),
          h = Math.floor(diff % 86400000 / 3600000),
          m = Math.floor(diff % 3600000 / 60000),
          s = Math.floor(diff % 60000 / 1000);
      if (els.d) els.d.textContent = pad(d);
      if (els.h) els.h.textContent = pad(h);
      if (els.m) els.m.textContent = pad(m);
      if (els.s) els.s.textContent = pad(s);
    };
    tick();
    setInterval(tick, 1000);
  }

  /* FAQ accordion */
  document.querySelectorAll('.faq-q').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.closest('.faq-item');
      var a = item.querySelector('.faq-a');
      var open = item.classList.toggle('open');
      a.style.maxHeight = open ? a.scrollHeight + 'px' : null;
    });
  });

  /* Product gallery */
  var mainImg = document.querySelector('.gallery .main img');
  if (mainImg) {
    document.querySelectorAll('.gallery .thumbs img').forEach(function (t) {
      t.addEventListener('click', function () {
        mainImg.src = t.src;
        document.querySelectorAll('.gallery .thumbs img').forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
      });
    });
  }

  /* WhatsApp deep-link: prefill clicked item */
  document.querySelectorAll('[data-item]').forEach(function (el) {
    el.addEventListener('click', function () {
      document.querySelectorAll('.js-wa').forEach(function (wa) {
        var base = wa.href.split('?')[0];
        wa.href = base + '?text=' + encodeURIComponent('Hello Iconix — I would like to enquire about the ' + el.dataset.item + '.');
      });
    });
  });

  /* Newsletter / enquiry stub */
  document.querySelectorAll('form[data-stub]').forEach(function (f) {
    f.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var note = f.querySelector('[data-note]');
      if (note) { note.textContent = 'Thank you — you are on the Iconix list. We will be in touch.'; note.style.color = 'var(--gold-light)'; }
      f.reset();
    });
  });
})();
